import SubscriptionAPI from '@/app/apis/main/subscription/subscription-api.js';

export default {
    /**
     * @param {*} userDetails
    */
    async subscribeEmail(userDetails) {
        return SubscriptionAPI.subscribeEmail(userDetails);
    },

    /**
	 * @return {*} frequency and subscription list
	 */
	async getSubscriptionPeriod() {
        return SubscriptionAPI.getSubscriptionPeriod();
    },

    /**
	 * @return {object} tracking subscription
	 * @param {petId}
	 */
	async getSubscriptionTrack(petId) {
        return SubscriptionAPI.getSubscriptionTrack(petId);
    },

    /**
	 * Retrieves subscription details for a given subscription ID.
	 * @async
	 * @param {string} subscriptionId - The ID of the subscription to retrieve details for.
	 * @returns {Promise<object>} A Promise that resolves to an object representing the subscription details.
	 */
	async getSubscriptionDetails(petId, subscriptionId) {
		return SubscriptionAPI.getSubscriptionDetails(petId, subscriptionId);
	},

	/**
	 * Requests cancellation of a subscription for a specific pet.
	 *
	 * @async
	 * @function requestSubscriptionCancellation
	 * @param {string|number} petId - The ID of the pet associated with the subscription to cancel.
	 * @param {string|number} subscriptionId - The ID of the subscription to cancel.
	 * @param {Object} subscriptionDetails - Additional details for the cancellation request.
	 * @param {string|number} subscriptionDetails.orderId - The ID of the order associated with the subscription.
	 * @param {string} subscriptionDetails.remarks - Any remarks associated with the cancellation request.
	 * @returns {Promise<Object>} A promise that resolves with the result of the cancellation request.
	 * @throws {Error} If an error occurs during the cancellation request.
	*/
	async requestSubscriptionCancellation(petId, subscriptionId, subscriptionDetails) {
		return SubscriptionAPI.requestSubscriptionCancellation(petId, subscriptionId, subscriptionDetails);
	},
}